<template>
  <div class="news-detail">
    <div class="nav-bar">
      <div>当前位置：</div>
      <router-link to="/">首页 >&nbsp; </router-link>
      <router-link to="/news">头条 >&nbsp; </router-link>
      <span style="color: #26d99d">推荐资讯</span> &nbsp;>&nbsp;
      <div>{{ article.title }}</div>
    </div>
    <div class="content">
      <div class="acticle-wrap">
        <div class="article">
          <div class="article-title">{{ article.title }}</div>
          <div class="article-mid">
            <!-- <img :src="avatar" alt="" /> -->
            <!-- <div class="name">{{ author }}</div> -->
            <div class="time">{{ article.publishTime }}</div>
          </div>
          <div
            ref="articleImg"
            class="article-up"
            v-html="article.content"
          ></div>
          <div class="article-down">
            <div
              @click="goPrevNextArticle(article.last_and_next[0].id)"
              v-if="article.last_and_next && article.last_and_next[0].title"
              class="prev"
            >
              <div class="prev-up">上一篇</div>
              <div class="prev-down">
                {{ article.last_and_next[0].title }}
              </div>
            </div>
            <div class="prev" v-else>
              <div class="prev-up">上一篇</div>
              <div class="prev-down">到头了</div>
            </div>
            <div
              @click="goPrevNextArticle(article.last_and_next[1].id)"
              v-if="article.last_and_next && article.last_and_next[1].title"
              class="next"
            >
              <div class="next-up">下一篇</div>
              <div class="next-down">{{ article.last_and_next[1].title }}</div>
            </div>
            <div class="next" v-else>
              <div class="next-up">下一篇</div>
              <div class="next-down">到头了</div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div class="list">
          <div class="news-recommend">
            <div class="news-recommend-title">推荐资讯</div>
            <router-link
              :to="`/news_detail/${item.id}`"
              target="_blank"
              v-for="(item, index) in newsList"
              :key="index"
              class="news-recommend-list"
            >
              <div class="left">
                <img :src="item.img" alt="" />
              </div>
              <div class="right">
                <div class="up">
                  {{ item.title }}
                </div>
                <div class="down">{{ item.publish_time }}</div>
              </div>
            </router-link>
          </div>
        </div>
        <AnchorRecommend :isLogin="isLogin" />
      </div>
    </div>
    <!-- <div class="wrap">
      <div class="left">
        <div class="title">
          <img src="./home_mod_toutiao.png" alt="" />
          <div>推荐资讯</div>
        </div>
        <div class="news-list">
          <router-link
            :to="`/news/${item.id}`"
            target="_blank"
            class="list"
            v-for="(item, index) in newsList"
            :key="index"
          >
            <div class="left"><img :src="item.img" alt="" /></div>
            <div class="right">
              <div class="mid right-common">{{ item.title }}</div>
              <div class="down right-common">{{ item.profile }}</div>
              <div class="up right-common">
                <div class="up-left">
                  <img :src="avatar" alt="" />
                  <div>{{ author }}</div>
                </div>
                <div class="up-right">{{ item.publish_time }}</div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="right"></div>
    </div> -->
  </div>
</template>

<script>
import { post, parseCookie } from "../../util/http";
import AnchorRecommend from "@/components/anchor-recommend/anchor-recommend";

export default {
  // metaInfo() {
  //   return {
  //     title: "Xôi Lạc TV - Trực Tiếp Bóng Đá Hôm Nay | Xem Bóng Đá Miễn Phí",
  //     meta: [
  //       {
  //         name: "keywords",
  //         content:
  //           "xoilac, xoilac tv, xôi lạc trực tiếp bóng đá hôm nay, truc tiep bong da, xem bong da truc tuyen",
  //       },
  //     ],
  //   };
  // },
  async asyncData({ params, req, error }) {
    let { id } = params;
    try {
      //请求文章详情接口
    } catch (err) {
      console.log(err);
    }
    return { id: parseInt(id) };
  },
  components: {
    AnchorRecommend,
  },
  data() {
    return {
      article: {},
      prevArticle: {},
      nextArticle: {},
      newsList: "",
      avatar: require("./live_biaoqing.png"),
      author: "",
      uid: 0,
      isLogin: false,
    };
  },
  async created() {
    // const cookie = document.cookie || "";
    // let { uid } = parseCookie(cookie);
    // this.uid = uid;
    // console.log("cookie", uid);
    if (this.uid) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
  },
  mounted() {
    this.getArticle(this.$route.params.id);
    this.getRecommenedNewsList();
  },
  methods: {
    goPrevNextArticle(id) {
      this.$router.push({ name: "news_detail", params: { id: id } });
      location.reload();
    },
    async getArticle(id) {
      const {
        data: { data },
      } = await post({
        url: "/api/news/getNewsById",
        data: {
          id: parseInt(id),
        },
      });
      this.article = data || {};
    },

    async getRecommenedNewsList() {
      const {
        data: { data },
      } = await post({
        url: "/api/news/getRecommenedNewsList",
      });
      this.newsList = data;
    },
  },
};
</script>

<style scoped lang="scss">
.news-detail {
  width: 14rem;
  margin: 0 auto;
  margin-bottom: 0.4rem;
  padding-top: 0.8rem;
  .nav-bar {
    height: 0.4rem;
    display: flex;
    align-items: center;
    text-align: center;
    font-size: 0.14rem;
    color: #333;
  }
  .content {
    display: flex;
    .article {
      width: 10.13rem;
      padding: 0.3rem;
      margin-right: 0.08rem;
      background-color: #fff;
      box-shadow: 0rem 0.03rem 0.12rem 0rem rgba(0, 0, 0, 0.1);
      border-radius: 0.08rem;
      .article-title {
        font-size: 0.24rem;
        font-weight: bold;
        margin: 0.1rem 0;
        text-align: center;
        line-height: 1.5;
      }
      .article-up {
        margin-top: 0.24rem;
        font-size: 0.16rem;
        color: #333;
        line-height: 2;
        ::v-deep img {
          max-width: 100%;
          height: 100%;
        }
      }
      .article-mid {
        display: flex;
        height: 0.4rem;
        margin-top: 0.2rem;
        align-items: center;
        justify-content: center;
        margin-top: -0.1rem;
        font-size: 0.16rem;
        color: #666;
        img {
          width: 0.24rem;
          height: 0.24rem;
          border-radius: 0.24rem;
          margin-right: 0.12rem;
        }
        .time {
          // flex: 1;
          // display: flex;
          // justify-content: flex-end;
          margin-left: 0.2rem;
          color: #999;
          font-size: 0.14rem;
        }
      }
      .article-down {
        margin-top: 0.1rem;
        display: flex;
        justify-content: space-between;
        color: #666;
        font-size: 0.16rem;
        a {
          color: #666;
        }
        .prev {
          height: 0.6rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          cursor: pointer;
        }
        .next {
          height: 0.6rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          cursor: pointer;
        }
        .prev-up {
          font-size: 0.16rem;
          color: #333;
          font-weight: bold;
          margin-bottom: 0.1rem;
        }
        .next-up {
          font-size: 0.16rem;
          color: #333;
          font-weight: bold;
          margin-bottom: 0.1rem;
          display: flex;
          justify-content: flex-end;
        }
        .prev-down {
          width: 4.5rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .next-down {
          width: 4.5rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: right;
        }
      }
    }
    .list {
      flex: 1;
      .news-recommend {
        margin-bottom: 0.15rem;
        background-color: #fff;
        border-radius: 0.08rem;
        display: flex;
        flex-direction: column;
        box-shadow: 0rem 0.03rem 0.12rem 0rem rgba(0, 0, 0, 0.1);
        .news-recommend-title {
          height: 0.48rem;
          background: linear-gradient(
            to right,
            rgba(41, 241, 156, 0.2),
            rgba(2, 161, 249, 0.2)
          );
          border-radius: 0.08rem 0.08rem 0 0;
          display: flex;
          align-items: center;
          padding-left: 0.16rem;
          font-size: 0.16rem;
          color: #333;
          font-weight: bold;
        }
        .news-recommend-list {
          padding: 0.16rem 0;
          margin: 0 0.12rem;
          display: flex;
          border-bottom: 0.01rem solid #f0f0f0;
          .left {
            width: 1.5rem;
            height: 0.92rem;
            border-radius: 0.08rem;
            overflow: hidden;
          }
          .left img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: all 0.6s;
          }
          .left img:hover {
            transform: scale(1.4);
          }
          .right {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 0.04rem 0;
            margin-left: 0.08rem;
            .up {
              color: #333;
              font-size: 0.16rem;
              font-weight: bold;
              overflow: hidden;
              display: -webkit-box; //作为弹性伸缩盒子模型显示。
              -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
              -webkit-line-clamp: 2; //显示的行
            }
            .down {
              color: #999;
              font-size: 0.14rem;
            }
          }
        }
      }
    }
  }
  // .wrap {
  //   display: flex;
  //   .left {
  //     width: 8.94rem;
  //     .title {
  //       display: flex;
  //       margin-top: .08rem;
  //       width: 1.5rem;
  //       height: .8rem;
  //       align-items: center;
  //       font-size: .24rem;
  //       color: #333;
  //       font-weight: 500;
  //       img {
  //         width: .32rem;
  //         height: .32rem;
  //         margin-right: .08rem;
  //       }
  //     }
  //     .news-list {
  //       width: 8.94rem;
  //       background-color: #fff;
  //       border-radius: .08rem;
  //       box-shadow: 0rem .03rem .12rem 0rem rgba(0, 0, 0, 0.1);
  //       .list {
  //         display: flex;
  //         margin: 0 .24rem;
  //         padding: .24rem 0;
  //         border-bottom: .01rem solid #f0f0f0;
  //         .left {
  //           width: 2.12rem;
  //           height: 1.08rem;
  //           border-radius: .08rem;
  //           overflow: hidden;
  //         }
  //         .left img {
  //           width: 100%;
  //           height: 100%;
  //           object-fit: cover;
  //           transition: all 0.6s;
  //         }
  //         .left img:hover {
  //           transform: scale(1.4);
  //         }
  //         .right {
  //           display: flex;
  //           flex-direction: column;
  //           justify-content: space-between;
  //           width: 100%;
  //           margin-left: .16rem;
  //           .right-common {
  //             display: flex;
  //             height: .36rem;
  //           }
  //           .up {
  //             justify-content: space-between;
  //             font-size: .14rem;
  //             align-items: center;
  //             color: #999;
  //             .up-left {
  //               color: #666;
  //               display: flex;
  //               align-items: center;
  //             }
  //             .up-left img {
  //               width: .24rem;
  //               height: .24rem;
  //               border-radius: .24rem;
  //               margin-right: .12rem;
  //             }
  //           }
  //           .mid {
  //             font-size: .18rem;
  //             color: #333;
  //             font-weight: bold;
  //             white-space: nowrap;
  //             overflow: hidden;
  //             text-overflow: ellipsis;
  //           }
  //           .down {
  //             font-size: .16rem;
  //             color: #999;
  //             font-weight: 400;
  //             line-height: 1.2;
  //             overflow: hidden;
  //             display: -webkit-box; //作为弹性伸缩盒子模型显示。
  //             -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
  //             -webkit-line-clamp: 2; //显示的行
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
}
</style>
